<ng-container *ngIf="showSuccess">
  <div class="partner-success-screen">
    <!-- <div class="partner-success-hero">
      <p class="partner-success-hero__subtitle">{{ 'pages.partnerRegistration.success.heroSubtitle' | i18n }}</p>
    </div> -->

    <div class="inscription-form-flow">
      <umkt-card-wrapper
        class="company-registration-card partner-inscription-success-card"
        [title]="''"
        [hideHeader]="true"
        [variant]="'default'"
      >
        <div class="company-card-top company-card-top--success">
          <div class="company-card-header">
            <div class="company-card-icon company-card-icon--success" aria-hidden="true">
              <span class="mdn-Icon-check mdn-Icon--md company-card-success-icon" aria-hidden="true"></span>
            </div>
            <div class="company-card-text company-card-text--success-header">
              <h2 class="company-card-title">{{ 'pages.partnerRegistration.success.cardTitle' | i18n }}</h2>
            </div>
          </div>
        </div>

        <div class="company-card-bottom company-card-bottom--success">
          <p class="partner-success__text">{{ 'pages.partnerRegistration.success.body1' | i18n }}</p>
        </div>
      </umkt-card-wrapper>
    </div>
  </div>

  <section class="partner-area-cta" aria-labelledby="partner-success-cta-title">
    <div class="partner-area-cta__top-gap" aria-hidden="true"></div>
    <div class="partner-area-cta__content">
      <div class="partner-area-cta__text-group">
        <h2 id="partner-success-cta-title" class="partner-area-cta__title">
          {{ 'pages.partnerRegistration.success.cta.title' | i18n }}
        </h2>
        <p class="partner-area-cta__description">
          {{ 'pages.partnerRegistration.success.cta.description' | i18n }}
        </p>
      </div>
      <button type="button" class="partner-area-cta__button" (click)="onPartnerPortalClick()">
        {{ 'pages.partnerRegistration.success.cta.button' | i18n }}
      </button>
    </div>
    <div class="partner-area-cta__bottom-gap" aria-hidden="true"></div>
  </section>
</ng-container>
